module.exports = __webpack_public_path__ + "static/media/serenedry-5.58111cf2.png";